import React from 'react';

interface ITruncateTextProps {
    text: string;
    maxLength: number;
    truncateOnWord?: boolean;
    includeElipsis?: boolean;
}

const TruncateText: React.FC<ITruncateTextProps> = ({ text, maxLength, truncateOnWord = true, includeElipsis = true }) => {
    if (text.length <= maxLength) {
        return <>{text}</>;
    }

    const truncatedText = truncateOnWord ? text.substring(0, text.lastIndexOf(' ', maxLength)) : text.substring(0, maxLength);

    return <>{truncatedText}{includeElipsis ? '...' : ''}</>;
};

export default TruncateText;